export default {
  // Auth pages
  'signIn.title': 'Sign In',
  'signIn.subtitle': 'Welcome back to PackVerse',
  'signIn.email': 'Email Address',
  'signIn.password': 'Password',
  'signIn.forgotPassword': 'Forgot Password?',
  'signIn.button': 'Sign In',
  'signIn.noAccount': "Don't have an account?",
  'signIn.signUpLink': 'Sign Up',
  'signIn.or': 'Or continue with',
  'signIn.google': 'Google',
  'signIn.facebook': 'Facebook',
  'signIn.error.invalid': 'Invalid email or password',
  'signIn.error.noSupabase': 'Server connection is not configured. Please contact support.',
  'signIn.error.generic': 'An error occurred. Please try again.',

  'signUp.title': 'Create Account',
  'signUp.subtitle': 'Join PackVerse for free',
  'signUp.fullName': 'Full Name',
  'signUp.email': 'Email Address',
  'signUp.password': 'Password',
  'signUp.passwordHint': 'At least 6 characters',
  'signUp.confirmPassword': 'Confirm Password',
  'signUp.button': 'Create Account',
  'signUp.hasAccount': 'Already have an account?',
  'signUp.signInLink': 'Sign In',
  'signUp.or': 'Or sign up with',
  'signUp.google': 'Google',
  'signUp.facebook': 'Facebook',
  'signUp.error.passwordMatch': 'Passwords do not match',
  'signUp.error.weakPassword': 'Password must be at least 6 characters',
  'signUp.error.noSupabase': 'Server connection is not configured. Please contact support.',
  'signUp.error.generic': 'An error occurred during sign up. Please try again.',
  'signUp.success': 'Account created successfully! Please check your email to verify.',
  'signUp.terms': 'By signing up, you agree to our Terms of Service and Privacy Policy.',

  'logout': 'Logout',
  'myAccount': 'My Account',
  'dashboard': 'Dashboard',

  'customerAccount': 'Customer Account',
  'adminBadge': 'Admin',
  'myQuotes': 'My Quotes',
  'myOrders': 'My Orders',
  'aiPreviews': 'AI Finish Previews',
  'savedProducts': 'Saved Products',
  'companyProfile': 'Company Profile',
  'shippingAddress': 'Shipping Address',
  'accountSettings': 'Account Settings',
  'adminConsole': 'Admin Console',
};